import { render, staticRenderFns } from "./create-ticket.vue?vue&type=template&id=3f2d4f42&scoped=true&"
import script from "./create-ticket.vue?vue&type=script&lang=ts&"
export * from "./create-ticket.vue?vue&type=script&lang=ts&"
import style0 from "./create-ticket.vue?vue&type=style&index=0&id=3f2d4f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d4f42",
  null
  
)

component.options.__file = "create-ticket.vue"
export default component.exports